'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024$0024anon$0024136 from "./presto.types$-User-Id$$anon$136.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserId$() {
  this.ccU = null;
  this.ccV = false;
  this.ccS = null;
  this.ccT = false;
  this.ccW = null;
  this.ccX = false;
  this.ccY = null;
  this.ccZ = false;
}
export { $c_Lpresto_types$UserId$ as $c_Lpresto_types$UserId$ };
$p = $c_Lpresto_types$UserId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserId$;
/** @constructor */
function $h_Lpresto_types$UserId$() {
}
export { $h_Lpresto_types$UserId$ as $h_Lpresto_types$UserId$ };
$h_Lpresto_types$UserId$.prototype = $p;
$p.ado = (function() {
  if ((!this.ccV)) {
    this.ccU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j1;
    this.ccV = true;
  }
  return this.ccU;
});
$p.jW = (function() {
  if ((!this.ccT)) {
    this.ccS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().eB;
    this.ccT = true;
  }
  return this.ccS;
});
$p.cIi = (function() {
  if ((!this.ccX)) {
    this.ccW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$33) => {
      var t = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(_$33);
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_RTLong$().ig(t.e, t.f);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ccX = true;
  }
  return this.ccW;
});
$p.SD = (function() {
  if ((!this.ccZ)) {
    this.ccY = new $j_presto$002etypes$0024$002dUser$002dId$0024$0024anon$0024136.$c_Lpresto_types$UserId$$anon$136(this);
    this.ccZ = true;
  }
  return this.ccY;
});
var $d_Lpresto_types$UserId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserId$, "presto.types$UserId$", ({
  a31: 1,
  D: 1
}));
export { $d_Lpresto_types$UserId$ as $d_Lpresto_types$UserId$ };
var $n_Lpresto_types$UserId$;
function $m_Lpresto_types$UserId$() {
  if ((!$n_Lpresto_types$UserId$)) {
    $n_Lpresto_types$UserId$ = new $c_Lpresto_types$UserId$();
  }
  return $n_Lpresto_types$UserId$;
}
export { $m_Lpresto_types$UserId$ as $m_Lpresto_types$UserId$ };
//# sourceMappingURL=presto.types$-User-Id$.js.map
